<template>
<div container--fluid>
    <v-layout>
        <OrderDetailModule :order-oid="order_id" :typeorig="typeorig"></OrderDetailModule>
    </v-layout>
</div>
</template>

<script>
import OrderDetailModule from '@modules/order/detail.vue';

export default {
    name: 'orderDetail',
    components: {
        OrderDetailModule,
    },
    props: {
        'order_id': {
            type: [Number, String],
            required: true
        },
        'typeorig': {
            type: [String],
        }
    },
    data(){
        return {
            //
        }
    },
};
</script>

<style scoped>

</style>
